import { render, staticRenderFns } from "./Bulkupload.vue?vue&type=template&id=1f56b7c6&scoped=true"
import script from "./Bulkupload.vue?vue&type=script&lang=js"
export * from "./Bulkupload.vue?vue&type=script&lang=js"
import style0 from "./Bulkupload.vue?vue&type=style&index=0&id=1f56b7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56b7c6",
  null
  
)

export default component.exports